import { render, staticRenderFns } from "./ActionsPullRequest.vue?vue&type=template&id=7a499b71&"
import script from "./ActionsPullRequest.vue?vue&type=script&lang=ts&"
export * from "./ActionsPullRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports